import { api } from '@/services'
export function update(questionId, params) {
    return api.post(`/admin/answerOption/update/${questionId}`, params)
}